/* Shared dropdown navigation for desktop and mobile. */
(() => {
  const header = document.querySelector('header.numuti-header');
  if (!header) return;
  const toggle = header.querySelector('.mobile-menu-toggle');
  const navigation = header.querySelector('#numuti-mobile-menu');
  if (!toggle || !navigation) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  let open = false;

  function render() {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    navigation.hidden = !open;
  }
  function close(returnFocus = false) {
    open = false;
    render();
    if (returnFocus) toggle.focus();
  }

  toggle.hidden = false;
  header.classList.add('mobile-nav-ready');
  render();
  toggle.addEventListener('click', () => {
    open = !open;
    render();
  });
  toggle.addEventListener('keydown', event => {
    if (event.key !== 'ArrowDown') return;
    event.preventDefault();
    open = true;
    render();
    navigation.querySelector('a[href]')?.focus();
  });
  navigation.addEventListener('click', event => {
    if (event.target.closest('a[href]')) close();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && open) {
      event.preventDefault();
      close(true);
    }
  });
  document.addEventListener('click', event => {
    if (open && !header.contains(event.target)) close();
  });
  header.addEventListener('focusout', () => {
    requestAnimationFrame(() => {
      if (open && !header.contains(document.activeElement)) close();
    });
  });
  mobile.addEventListener('change', () => {
    const focusWasInNavigation = navigation.contains(document.activeElement);
    close(focusWasInNavigation);
  });
})();
